module.exports = __webpack_public_path__ + "f583a1b6e66e7642ce9e68b12ad494e8.png";